import styled from 'styled-components'
import Button from 'react-bootstrap/Button'

export const AuthButtonStyles = styled(Button)`
    background: #167fe0 ;
    font: inherit;

    :hover {
        color:#167fe0; 
        background: white;
        border-color: #167fe0;
      
    }
`
